<template>
  <ul v-if="localNavItems.length > 0" class="ns-secondary-nav">
    <li v-for="link in localNavItems" :key="link.name" class="list-item">
      <a class="nav-link" :href="link.href">
        <span>{{ link.name }}</span>
        <iron-icon
          class="right-arrow"
          icon="nuskin-24:icon-narrow-angle-right"
        />
      </a>
    </li>
  </ul>
</template>

<script>
export default {
  name: "NsSecondaryNav",
  props: {
    navItems: {
      type: [Array, String],
      default: function() {
        return [];
      }
    },
    arr: {
      type: [Array, String],
      default: function() {
        return [];
      }
    }
  },
  computed: {
    localNavItems() {
      return this.isJsonString(this.navItems)
        ? JSON.parse(this.navItems) || []
        : this.navItems || [];
    }
  },
  methods: {
    isJsonString(str) {
      try {
        JSON.parse(str);
      } catch (error) {
        return false;
      }
      return true;
    }
  }
};
</script>

<style lang="scss" scoped>
.ns-secondary-nav {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-column-gap: 15px;
  padding: 0 15px;
  width: 100%;
  box-sizing: border-box;
}

.list-item {
  padding: 12px 0;
  line-height: normal;
  text-align: left;
}

.nav-link {
  border-bottom: 1px solid transparent;
  color: rgb(99, 102, 106);
  font-size: 16px;
  font-weight: normal;
  line-height: normal;
  letter-spacing: 0px;
  text-decoration: none;
  transition: var(--global-transition);
  box-sizing: border-box;

  &:hover {
    border-bottom: 1px solid currentColor;
    color: rgb(39, 37, 37);
  }
}

.right-arrow {
  flex-shrink: 0;
  display: none;
  margin-left: 10px;
  width: 14px;
  height: 14px;
  color: var(--color-primary-button-hit);
}

@media (max-width: 767px) {
  .ns-secondary-nav {
    grid-template-columns: repeat(1, 1fr);
    margin: 0 0 5px;
  }

  .list-item {
    padding: 0;
    border-top: 1px solid rgb(187, 188, 188);
  }

  .nav-link {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 12px 10px;
    width: 100%;
  }

  .right-arrow {
    display: block;
  }
}
</style>
